import { API_ROUTES } from "../../../utils/constants";
import _axios from "../index";


export default class organizationInfoService {

  Update_organization = async (body) => {
    try {
      const response = await _axios.patch(API_ROUTES.ORGANIZATION.UPDATE_ORGANIZATION, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Remove_organization = async () => {
    try {
      const response = await _axios.delete(API_ROUTES.ORGANIZATION.REMOVE_ORGANIZATION);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Add_organization_Roles = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.ADD_ORG_ROLES, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Schedule_Meet = async (body) => {
    try {
      const response = await _axios.post(API_ROUTES.ORGANIZATION.SCHEDULE_MEET, body);
      return response;
    } catch (err) {
      throw err;
    }
  };

  //  Get_organization_jobs = async (searchParams, status) => {
  //     try {
  //       const response = await _axios.get(`${API_ROUTES.ORGANIZATION.GET_ORG_JOBS}?${searchParams}`);
  //       return response;
  //     } catch (err) {
  //       throw err;
  //     }
  //   };

  // Get_organization_jobs = async (searchParams, status) => {
  //   try {
  //     // Construct query parameters dynamically
  //     const queryParams = new URLSearchParams();

  //     if (status) {
  //       queryParams.append("status", status);
  //     }

  //     if (searchParams) {
  //       queryParams.append("searchParams", searchParams);
  //     }

  //     const queryString = queryParams.toString(); // Convert to a query string

  //     // Make the API call with the constructed query string
  //     const response = await _axios.get(
  //       `${API_ROUTES.ORGANIZATION.GET_ORG_JOBS}?${queryString}`
  //     );

  //     return response;
  //   } catch (err) {
  //     throw err; // Handle the error appropriately
  //   }
  // };

//   Get_organization_jobs = async (searchParams, status) => {
//     try {
//         // Construct query parameters manually
//         let queryString = '';

//         if (status) {
//             queryString += `status=${status}&`;
//         }

//         if (searchParams) {
//             queryString += `${searchParams}`; // Directly append searchParams
//         }

//         // Remove any trailing "&" if present
//         queryString = queryString.replace(/&$/, "");

//         // Make the API call with the constructed query string
//         const response = await _axios.get(
//             `${API_ROUTES.ORGANIZATION.GET_ORG_JOBS}?${queryString}`
//         );

//         return response;
//     } catch (err) {
//         throw err;
//     }
// };

Get_organization_jobs = async (searchParams, status) => {
  if (!status) {
    return;
  }

  try {
    let queryString = '';
    queryString += `status=${encodeURIComponent(status)}&`;

    if (searchParams) {
      queryString += `${searchParams}`;
    }

    queryString = queryString.replace(/&$/, '');

    const response = await _axios.get(
      `${API_ROUTES.ORGANIZATION.GET_ORG_JOBS}?${queryString}`
    );

    return response;
  } catch (err) {
    throw err;
  }
};


  Update_organizationjob_status = async (jobId , status) => {
    try {
      const response = await _axios.patch(`${API_ROUTES.ORGANIZATION.UPDATE_STATUS_JOB}?jobId=${jobId}` , status);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_job_by_Id = async (jobId) => {
    try {
      const response = await _axios.get(`${API_ROUTES.ORGANIZATION.GET_JOB_BY_ID}/${jobId}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  
  Get_audits = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.ORGANIZATION.GET_AUDITS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_all_subscriptions = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.ORGANIZATION.GET_ALL_SUBSCRIPTIONS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

  Get_latest_subscriptions = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.ORGANIZATION.GET_LATEST_SUBSCRIPTION}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

    Get_All_Skills_Data = async () => {
    try {
      const response = await _axios.get(`${API_ROUTES.SKILLS.ALL_SKILLS}`);
      return response;
    } catch (err) {
      throw err;
    }
  };

}